import { Box } from "@chakra-ui/react";

import { ActualAppointments } from "modules/user/presentation";

import { HeaderText } from "components/HeaderText";

const ActualUserAppointments = () => {
  return (
    <Box>
      <HeaderText>Aktualne wizyty</HeaderText>
      <Box mt={4}>
        <ActualAppointments />
      </Box>
    </Box>
  );
};

export default ActualUserAppointments;
